<template>
    <select v-on:change="$emit('input', $event.target.value);">
        <option v-for="str in data" :key="str.id" v-html="str.title" :value="str.id"/>
    </select>
</template>

<script>
export default {
    props: ['data'],
    data(){
        return{
        }
    }
}
</script>
